exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promotionContainer{width:100%;max-width:580px;margin:auto;padding:0 16px}.promotionContainer p{margin:0}.promotionContainer img{width:auto;max-width:100%;display:block}.promotionContainer .row{margin-left:-16px;margin-right:-16px}.promotionContainer.-seimei{padding:0;background:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-615ea584","scoped":false,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/PromotionContainer.vue
// module id = ejQI
// module chunks = 0